import React from 'react';
import { Link } from 'react-router-dom';

const CampusLife = () => {
    return (
        <div className="events py-4">
            <div className="container">
                <h1 className="my-heading" style={{ marginLeft: "1rem" }}>
                    Campus Life
                </h1>
                <p className="ms-4 fs-5">A vibrant hub for innovation &amp; Creativity</p>
            </div>
            <div className="container main-events d-flex">
                <div className="calenders col-lg-9">
                    <div className="col-lg-4">
                        <div className="box">
                            <div className="top">
                                <h1>Sports</h1>
                            </div>
                            <div className="middle">
                                <img src="../../assets/images/sprts-11.jpg" alt="sports" />
                            </div>
                            <div className="content">
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to={"/sports-gallery"} className="normal-button">
                                        View More
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="box">
                            <div className="top">
                                <h1>Cultural</h1>
                            </div>
                            <div className="middle">
                                <img
                                    src="../../assets/images/cultural-program.jpg"
                                    alt="cultural-program"
                                />
                            </div>
                            <div className="content">
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to={"/cultural-gallery"} className="normal-button">
                                        View More
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="box">
                            <div className="top">
                                <h1>Academics</h1>
                            </div>
                            <div className="middle">
                                <img
                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/jpg/2024/05/Sports/Department/8.jpg"
                                    alt=""
                                />
                            </div>
                            <div className="content">
                                <div className="d-flex justify-content-center align-items-center">
                                    <Link to={"/academic-gallery"} className="normal-button">
                                        View More
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 imp-links">
                    <div className="box">
                        <div className="top">
                            <h1>Important links</h1>
                        </div>
                        <div className="content">
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item">
                                    <li className="accordion-header" id="headingOne">
                                        <button
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                        >
                                            UP State Universities Act
                                            <img src="../assets/images/faq-plus.svg" alt="" />
                                        </button>
                                    </li>
                                    <div
                                        id="collapseOne"
                                        className="accordion-collapse collapse"
                                        aria-labelledby="headingOne"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body">
                                            <li>
                                                <Link
                                                    to={"http://uphed.gov.in/pdf/univeristy_Acta.pdf"}
                                                    target="_blank"
                                                    style={{
                                                        textDecoration: "none",
                                                        color: "#14297a",
                                                        fontSize: 12
                                                    }}
                                                >
                                                    UP State Universities Act
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to={"https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/Ist-statude-of-the-ccsum.pdf"}
                                                    target="_blank"
                                                    style={{
                                                        textDecoration: "none",
                                                        color: "#14297a",
                                                        fontSize: 12
                                                    }}
                                                >
                                                    University Statutes
                                                </Link>
                                            </li>
                                            <li>
                                                <Link
                                                    to={"/governance"}
                                                    style={{
                                                        textDecoration: "none",
                                                        color: "#14297a",
                                                        fontSize: 12
                                                    }}
                                                >
                                                    University Ordinances
                                                </Link>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <li>
                                <Link
                                    to={"/rti"}
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Information Regarding RTI Act
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"/iqac"}
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Internal Quality Assurance Cell
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"https://scic.ccsuniversity.ac.in"}
                                    target="_blank"
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Startup Cell &amp; Incubation Center
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"/it-policy"}
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Information Technology Policy-2022
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"https://filesccsu.blr1.cdn.digitaloceanspaces.com/public/pdf/ccsum/policy/IPR%20POLICY.pdf"}
                                    target="_blank"
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    IPR Policy 2022
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"/phd-dlit"}
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Ph.D./ D.Litt.
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"/verification"}
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Documents Verification
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"https://nodal.ccsuniversity.ac.in"}
                                    target="_blank"
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Online Inventory for Campus
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"https://ccsums.ccsuniversity.ac.in/"}
                                    target="_blank"
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    CCTV Control Room Daily Report
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"http://www.ccsum.org.in"}
                                    target="_blank"
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Affiliation Portal
                                </Link>
                            </li>
                            <hr />
                            <li>
                                <Link
                                    to={"https://www.ccsum.org.in/cpanel.php?cid=306&page=insp"}
                                    target="_blank"
                                    style={{ textDecoration: "none", color: "#14297a" }}
                                >
                                    Affiliation Request for Cyber Crime Subject
                                </Link>
                            </li>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default CampusLife;